//export const API_DOMAIN = process.env.REACT_APP_NODE_ENV === 'production' ? '' : process.env.REACT_APP_NODE_ENV === 'staging' ? '' : 'http://localhost/sag-wordpress/wp-json/sag-api/v1';
//export const API_DOMAIN = process.env.REACT_APP_NODE_ENV === 'production' ? '' : process.env.REACT_APP_NODE_ENV === 'staging' ? 'http://www.greatapes.fi//clients/spaceapegames/sag-proto/mockdata' : 'http://localhost:3000/mockdata';

const env = process.env.REACT_APP_NODE_ENV;
const API_DOMAIN =
  env === 'production'
    ? 'https://www.spaceapegames.com'
    : env === 'staging' ? 'https://www.spaceapegames.com' : 'http://localhost';
const API_PATH =
  env === 'production'
    ? ''
    : env === 'staging'
      ? 'wp/wp-json/sag-api/v1'
      : 'sag-wordpress/wp-json/sag-api/v1';
const WP_PATH =
  env === 'production'
    ? 'sag-wordpress'
    : env === 'staging' ? 'wp' : 'sag-wordpress';

export const API_ROOT = `${API_DOMAIN}/${API_PATH}/`;
export const WP_ROOT = `${API_DOMAIN}/${WP_PATH}`;



// WEBPACK FOOTER //
// ./src/api/constants.js